import React from "react";
import classes from "./collapsable.module.css";
import Button from '../Auth/button'

const clickHandler = (e) => {
  const currentNode = e.target;
  const node = currentNode.parentElement;
  const Requirednode = node.nextElementSibling;
  
  currentNode.classList.toggle(classes["arrowDown_inverted"]);
  Requirednode.classList.toggle(classes["collapseBody_Collapsed"]);
  node.classList.toggle(classes["collapseHead_Collapsed"]);
};
const Collapsable = ({ heading, inputs, creatable, extraClass, collapseClass }) => {
  
  return (
    <div className={classes.collapse}>
      <div className={[classes.collapseHead, extraClass].join(' ')}>
        {heading}
        <i
          onClick={clickHandler}
          className={[classes.arrowDown, "fas fa-angle-down"].join(" ")}
        ></i>
      </div>
      <div className={[classes.collapseBody, collapseClass].join(' ')}>{inputs}
        {creatable&&creatable[0]?<Button onClick={creatable[1]} extraClass={classes.addResponseBtn}>add response</Button>:null}
      </div>
    </div>
  );
};

export default Collapsable;
